module.exports = __webpack_public_path__ + "media/images/icons/outlined/pic-center-ef706ecc73b227119319ce98ed5d7596.svg";